(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["az-atc-sticky"] && !Shopify.designMode) return;
  try {
    
(function () {
  const bar = document.getElementById('az-sticky-atc');
  if (!bar) return;

  document.body.classList.add('az-sticky-atc--active');

  const btn = bar.querySelector('#az-sticky-atc-btn');
  const priceEl = bar.querySelector('.az-sticky-atc__btn-price');
  const prices = JSON.parse(bar.querySelector('[data-az-sticky-prices]').textContent);

  // Variante elegida en la ficha (Dawn actualiza este input al cambiar de opción; vacío = combinación no disponible)
  const selectedVariantId = () => {
    const input = document.querySelector('product-form .product-variant-id, form.installment input[name="id"]');
    return input ? input.value : bar.dataset.variantId;
  };

  document.addEventListener('change', (event) => {
    if (event.target.name !== 'id') return;
    const price = prices[selectedVariantId()];
    if (price) priceEl.textContent = price;
  });

  btn.addEventListener('click', () => {
    if (btn.getAttribute('aria-disabled') === 'true') return;

    const variantId = selectedVariantId();
    if (!variantId) return;
    btn.setAttribute('aria-disabled', 'true');

    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');

    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', 1);
    if (cart) {
      body.append('sections', cart.getSectionsToRender().map((section) => section.id));
      body.append('sections_url', window.location.pathname);
      cart.setActiveElement(document.activeElement);
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = body;

    fetch(routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          console.error(response.errors || response.description);
          return;
        }
        if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }
        cart.renderContents(response);
      })
      .catch((e) => console.error(e))
      .finally(() => btn.removeAttribute('aria-disabled'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-comparative"] && !Shopify.designMode) return;
  try {
    
class AzVsBtn extends HTMLElement {
  connectedCallback() {
    this.querySelector('button').addEventListener('click', () => {
      const atc = document.querySelector('.grab_the_deal, .product-form__submit, [name="add"], button[data-add-to-cart]');
      if (!atc) return;
      atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => atc.click(), 500);
    });
  }
}

if (!customElements.get('az-vs-btn')) {
  customElements.define('az-vs-btn', AzVsBtn);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-estadistica-V1"] && !Shopify.designMode) return;
  try {
    
(function() {
  var animado = new Set();

  function animarContador(el) {
    if (animado.has(el)) return;
    animado.add(el);
    var objetivo = parseFloat(el.dataset.target);
    var sufijo = el.dataset.sufijo || '';
    var esDecimal = el.dataset.decimal === 'true';
    var duracion = 1200;
    var pasos = 40;
    var actual = 0;
    var incremento = objetivo / pasos;
    var intervalo = setInterval(function() {
      actual += incremento;
      if (actual >= objetivo) {
        actual = objetivo;
        clearInterval(intervalo);
      }
      el.textContent = (esDecimal ? actual.toFixed(2).replace('.', ',') : Math.round(actual)) + sufijo;
    }, duracion / pasos);
  }

  var contadores = document.querySelectorAll('.stats-contador');
  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        animarContador(entry.target);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.5 });

  contadores.forEach(function(el) { observer.observe(el); });

  var interior = document.querySelector('.stats-interior');
  var dotsWrapper = document.querySelector('.stats-dots');
  if (!interior || !dotsWrapper) return;

  var celdas = interior.querySelectorAll('.stats-celda');
  var dots = [];

  celdas.forEach(function(_, i) {
    var dot = document.createElement('button');
    dot.className = 'stats-dot' + (i === 0 ? ' activo' : '');
    dot.setAttribute('aria-label', 'Estadística ' + (i + 1));
    dot.addEventListener('click', function() {
      interior.scrollTo({ left: interior.offsetWidth * i, behavior: 'smooth' });
    });
    dotsWrapper.appendChild(dot);
    dots.push(dot);
  });

  interior.addEventListener('scroll', function() {
    var indice = Math.round(interior.scrollLeft / interior.offsetWidth);
    dots.forEach(function(dot, i) {
      dot.classList.toggle('activo', i === indice);
    });
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-midpage-cta"] && !Shopify.designMode) return;
  try {
    
class AzCtaButton extends HTMLElement {
  connectedCallback() {
    this.querySelector('button').addEventListener('click', () => {
      const atc = document.querySelector('.grab_the_deal, .product-form__submit, [name="add"], button[data-add-to-cart]');
      if (!atc) return;
      atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(() => atc.click(), 500);
    });
  }
}

if (!customElements.get('az-cta-button')) {
  customElements.define('az-cta-button', AzCtaButton);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-stats"] && !Shopify.designMode) return;
  try {
    
class AzStatsCount extends HTMLElement {
  #observer = null;

  connectedCallback() {
    this.#observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          this.#startCount();
          this.#observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #startCount() {
    const target = parseFloat(this.dataset.target);
    const suffix = this.dataset.suffix || '';
    const isDecimal = this.dataset.target.includes('.');
    const duration = 1400;
    let start = null;

    const step = (ts) => {
      if (!start) start = ts;
      const progress = Math.min((ts - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = target * eased;
      this.textContent = (isDecimal
        ? current.toFixed(2).replace('.', ',')
        : Math.floor(current)) + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        this.textContent = (isDecimal ? String(target).replace('.', ',') : String(target)) + suffix;
      }
    };

    requestAnimationFrame(step);
  }
}

if (!customElements.get('az-stats-count')) {
  customElements.define('az-stats-count', AzStatsCount);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-ug"] && !Shopify.designMode) return;
  try {
    
class AzUgcCard extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('[data-dialog]');
    if (!btn) return;

    const dialog = this.querySelector('.az-ugc__dialog');
    if (!dialog) return;

    const closeBtn = dialog.querySelector('.az-ugc__dialog-close');
    const video = dialog.querySelector('video');

    btn.addEventListener('click', () => {
      dialog.showModal();
      video?.play();
    });

    closeBtn?.addEventListener('click', () => {
      this.#closeDialog(dialog, video);
    });

    dialog.addEventListener('click', (e) => {
      if (e.target === dialog) this.#closeDialog(dialog, video);
    });

    dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this.#closeDialog(dialog, video);
    });
  }

  #closeDialog(dialog, video) {
    video?.pause();
    video?.load();
    dialog.close();
  }
}

if (!customElements.get('az-ugc-card')) {
  customElements.define('az-ugc-card', AzUgcCard);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
